export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6728.cca2cef2.jpg";